/* FAQ page — active sidebar link on scroll (ported from approved source). */
(function () {
  var catLinks = document.querySelectorAll('.faq-cat-link');
  var catSects = document.querySelectorAll('.faq-category-section');
  function updateActiveLink() {
    var scrollY = window.scrollY;
    var active = null;
    catSects.forEach(function (sect) {
      var top = sect.getBoundingClientRect().top + scrollY - 120;
      if (scrollY >= top) active = sect.id;
    });
    catLinks.forEach(function (link) {
      var href = link.getAttribute('href').replace('#', '');
      link.classList.toggle('active', href === active);
    });
  }
  window.addEventListener('scroll', updateActiveLink, { passive: true });
  updateActiveLink();
})();